/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// TODO Unit testy.
/**
 * Továrna na zdroje funkcionalit v podobě HTML video elementů.
 * @implements {ViewerSourceFactory}
 */
class ViewerSourceVideoFactory {
  /**
   * Vytvoří instanci.
   * @param {Class.<ViewerSourceVideo>} ViewerSourceVideo Konstruktor zdroje video elementu.
   * @param {ViewerFrameFactory} frameFactory
   * @returns {ViewerSourceVideoFactory} Nová instance.
   */
  constructor(ViewerSourceVideo, frameFactory) {
    this.ViewerSourceVideo = ViewerSourceVideo;
    this.frameFactory = frameFactory;
    this.parentEl = null;
  }

  /** @inheritdoc */
  create() {
    return new this.ViewerSourceVideo(this.frameFactory, this.parentEl);
  }

  /** @inheritdoc */
  delete(source) {
    return source.destroy();
  }

  /** @inheritdoc */
  setParentEl(parentEl) {
    this.parentEl = parentEl;
  }
}

export default ViewerSourceVideoFactory;
